//////////// WARNING ////////////
// This controller is meant to be generic. No specific code should be inserted here as
// it would create a risk to break the behavior where the controller is used (at several places).
/////////////////////////////////

import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["links", "template"];

  connect() {}

  addAssociation(event) {
    event.preventDefault();
    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime());
    let position = "beforebegin";
    const specificPosition = this.linksTarget.dataset.position;
    if (specificPosition) {
      position = specificPosition;
    }

    this.linksTarget.insertAdjacentHTML(position, content);

    if (event.target.dataset.source === "pictures") {
      const element = document.querySelector(".bo-pictures-container");
      const pictureController = this.application.getControllerForElementAndIdentifier(element, "bo-pictures");
      pictureController.reOrderAll();
    }
  }

  removeAssociation(e) {
    e.preventDefault();

    const wrapper = e.target.closest(".nested-fields");

    if (wrapper.dataset.newRecord === "true") {
      wrapper.remove();
    } else {
      wrapper.querySelector("input[name*='_destroy']").value = 1;
      wrapper.style.display = "none";
    }
  }
}
